import styled from "styled-components";

const DTEHR = styled.hr`
  margin: 10px 0;
`;

export default DTEHR;
